import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './style.css'

/* global gtag */ // não remover essa linha, ela é necessária para o Google Tag Manager

function CookieConsentBanner() {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        const consentimentoSalvo = localStorage.getItem('cookieConsent');
        if (!consentimentoSalvo) {
            setShowBanner(true);
        }
    }, []);

    const acceptAllCookies = (isAccept) => {
        const cookieConsent = {
            'ad_storage': isAccept ? 'granted' : 'denied',
            'ad_user_data': isAccept ? 'granted' : 'denied',
            'ad_personalization': isAccept ? 'granted' : 'denied',
            'analytics_storage': isAccept ? 'granted' : 'denied',
        };
        gtag('consent', 'update', cookieConsent);
        localStorage.setItem('cookieConsent', JSON.stringify(cookieConsent));
        setShowBanner(false);
    }


    if (!showBanner) return null;

    return (
        <div className="cookie-banner">
            <p className="cookie-text">
                Utilizamos cookies para melhorar sua experiência de navegação. Ao continuar no site, você concorda com a utilização desses cookies.
                Consulte nossa <Link to="politica-de-privacidade" className="cookie-link">Política de Privacidade</Link> para saber mais.
            </p>
            <div className="cookie-actions">
                <button
                    onClick={() => acceptAllCookies(false)}
                    className="cookie-button secondary"
                >
                    Aceitar apenas os necessários
                </button>
                <button
                    onClick={() => acceptAllCookies(true)}
                    className="cookie-button primary"
                >
                    Aceitar Todos
                </button>
            </div>
        </div>
    );
}

export default CookieConsentBanner;